<script lang="ts">
	import { onMount } from "svelte";

	let { onVisible }: { onVisible: () => void } = $props();

	let element: HTMLDivElement;

	onMount(() => {
		const observer = new IntersectionObserver(([entry]) => {
			if (entry.isIntersecting) {
				onVisible();
			}
		}, {});

		observer.observe(element);
	});
</script>

<div bind:this={element} class="indicator"></div>

<style>
	.indicator {
		height: 1px;
		width: 1px;
	}
</style>
